import { ref, computed } from "vue";

export function useFootnoteExtraText(itemRef, updateFn, options = {}) {
  const { onSave = null, clearExtraTextValue = "" } = options;

  const showExtraTextInput = ref(false);

  const hasFootnote = computed(() => {
    const item = itemRef.value;
    return !!item?.footnote_text;
  });

  const hasExtraText = computed(() => {
    const item = itemRef.value;
    return item?.extra_text !== null && item?.extra_text !== undefined && item?.extra_text !== "";
  });

  const showExtraText = computed(() => hasExtraText.value || showExtraTextInput.value);

  function toggleFootnote(checked) {
    if (checked) {
      updateFn({ footnote_text: itemRef.value?.footnote_text || " " });
    } else {
      updateFn({
        footnote_text: "",
        custom_footnote_char: "",
        footnote_on_amount: false,
      });
    }
    onSave?.();
  }

  function toggleExtraText(checked) {
    if (checked) {
      showExtraTextInput.value = true;
    } else {
      showExtraTextInput.value = false;
      updateFn({ extra_text: clearExtraTextValue });
      onSave?.();
    }
  }

  function updateExtraText(value) {
    updateFn({ extra_text: value });
    onSave?.();
  }

  return {
    hasFootnote,
    hasExtraText,
    showExtraText,
    showExtraTextInput,
    toggleFootnote,
    toggleExtraText,
    updateExtraText,
  };
}
